// Copyright (C) 2021-Present CITEC Inc. <https://citecsolutions.com/>
// All rights reserved
//
// This file is part of CITEC Inc. source code.
// This software framework contains the confidential and proprietary information
// of CITEC Inc., its affiliates, and its licensors. Your use of these
// materials is governed by the terms of the Agreement between your organization
// and CITEC Inc., and any unauthorized use is forbidden. Except as otherwise
// stated in the Agreement, this software framework is for your internal use
// only and may only be shared outside your organization with the prior written
// permission of CITEC Inc.
// CITEC Inc. source code can not be copied and/or distributed without the express
// permission of CITEC Inc.

import { AppIcon } from '@shared/ui-kit/components/app-icon';
import { useState } from 'react';
import { useDispatch } from 'react-redux';
import { useAppSelector } from '@advisor-app/store/store';
import {
  selectTargetPortfolio,
  portfolioPositionsSlice,
} from '@shared/data-access/slices/portfolio-positions';
import { useTranslation } from 'react-i18next';

export const RebalanceAddPosition = (): JSX.Element => {
  const dispatch = useDispatch();
  const targetPortfolio = useAppSelector(selectTargetPortfolio);
  const [text, setText] = useState('');
  const [isAssetInPortfolio, setIsAssetInPortfolio] = useState(false);
  const { t } = useTranslation();

  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const value = e.target.value.toUpperCase();
    setText(value);

    const assetExistsInPortfolio = targetPortfolio.find(
      asset => asset.ticker === value,
    );

    setIsAssetInPortfolio(!!assetExistsInPortfolio);
  };

  const handleSelectValue = (ticker: string) => {
    dispatch(
      portfolioPositionsSlice.actions.updateTargetPortfolioPosition({
        ticker: ticker,
        weight: 0,
      }),
    );
    setText('');
  };

  return (
    <div className="input-ticker relative" data-testid="search-ticker">
      <input
        className="input-rounded"
        value={text}
        onChange={handleInputChange}
        name="search_text"
        placeholder={t('rebalance.add-ticker', { ns: 'rebalance' })}
        required
        type="text"
        autoComplete="off"
      />
      <div className="absolute right-3 top-1.5">
        <button
          type="submit"
          data-testid="btn-add-row"
          className="inline-flex h-7 w-7 items-center justify-center hover:cursor-pointer"
          disabled={!text || isAssetInPortfolio}
          onClick={() => handleSelectValue(text)}
        >
          <AppIcon
            icon="Add"
            size="lg"
            color="disabled"
            className="hover:!text-primary"
          />
        </button>
      </div>
    </div>
  );
};
